
<main>
  <section>
    <!-- ----- Section Hero ----- -->
    <ngb-carousel [interval]="carouselInterval" *ngIf="heroSlides > 0">
      <ng-template *ngFor="let i of [].constructor(heroSlides); let index = index" ngbSlide>
        <div class="image-container-hero">
          <img *ngIf="homeInfo.Slide_Imagens[index].mime == 'image/png'" [src]="homeInfo.Slide_Imagens[index].url" alt="{{homeInfo.Slide[index].Slide_Titulo}}"/>
          <video *ngIf="homeInfo.Slide_Imagens[index].mime == 'video/mp4'" controls autoplay mute loop (play)="onVideoPlay()" (pause)="onVideoPause()" (ended)="onVideoEnded()">
            <source [src]="homeInfo.Slide_Imagens[index].url" type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
          <!--<div class="black-overlay"></div>-->
          <div class="carousel-caption">
            <h2 class="color-white text-shadow-linhas fs-325remTitles">{{ homeInfo.Slide[index].Slide_Titulo }}</h2>
            <h3 class="color-primary fs-2rem"><span class="text-shadow-linhas">{{ homeInfo.Slide[index].Slide_Subtitulo }}</span></h3>
            <button *ngIf="homeInfo.Slide[index].Slide_Botao_Link != null" title="{{homeInfo.Slide[index].Slide_Botao_Texto}}" class="btn-custom btn-3 my-3" [routerLink]="homeInfo.Slide[index].Slide_Botao_Link">
              <span><p class="my-auto fw-600">{{ homeInfo.Slide[index].Slide_Botao_Texto }}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span>
            </button>
          </div>
        </div>
      </ng-template>
    </ngb-carousel>

    <!-- ----- Section Marquee ----- -->
    <div class="bg-secondary w-marquee float-end h-marquee">
      <div class="container-fluid p-0">
        <div class="row g-0">
          <div class="col-12 p-marquee shadow-linhas">
            <div class="box">
              <div class="circle shadow-linhas"></div>
            </div>
            <om-marquee [reverse]="false" [animationDuration]="'20s'" [marqueeGap]="'3rem'" [pauseOnHover]="true" styleClass="custom-marquee">
              <div *ngFor="let marquee of homeInfo.CarrosselTexto" #OmMarqueeContent class="d-inline-flex align-items-center">
                <div class="marquee-text" [innerHTML]="marquee.HTML"></div>
                <span class="bullet-marquee"></span></div>
            </om-marquee>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="homepageResponsive">
    <!-- ----- Alertas e Avisos ----- -->
    <div id="warnings" class="alertsHomepage">
      <div class="container ptb-120-50 gx-lg-0 gx-5">
        <div class="row justify-content-center m-0">
          <div class="col-lg-9 col-md-12 col-10 p-0">
            <div class="row justify-content-between align-items-center bg-secondary py-3 bdr-r-t-10 bdr-c-ltr">
              <div class="col">
                <p class="fs-20px bold color-white m-0">{{ homeInfo.Avisos_Alertas }}</p>
              </div>
            </div>
            <div class="row justify-content-center bg-grey-soft p-custom-2-1rem bdr-r-b-10 bdr-c-lbr max-height700">
              <!-- ----- Filtros Alertas ----- -->
              <ng-container *ngIf="warningsListSize == 0">
                <div class="row alertsHomepageCollapse">
                  <div class="col-lg-12 col-12">
                    <p class="fw-800 text-center m-0">{{ homeInfo.Avisos_Alertas_Sem_Avisos }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="warningsListSize > 0">
                <div class="alertsHomepageFilters">
                  <form [formGroup]="searchForm" *ngIf="searchForm">
                    <div class="row">
                      <div class="col-lg-4 col-12">
                        <label aria-label="Município" class="mb-1">{{ 'formLabels.municipio' | translate }}</label>
                        <select aria-label="Selecionar Município" formControlName="municipality" class="form-select">
                          <option value="" selected>{{ 'formPlaceholders.selecionar' | translate }}</option>
                          <option *ngFor="let municipality of municipalities"
                                  value="{{municipality.code + '##'+ municipality.name}}">{{ municipality.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg col-12 mt-2 mt-lg-0">
                        <label aria-label="Linha" class="mb-1">{{ 'formLabels.linha' | translate }}</label>
                        <select aria-label="Selecionar Linha" formControlName="line" class="form-select">
                          <option value="" selected>{{ 'formPlaceholders.selecionar' | translate }}</option>
                          <option *ngFor="let line of lines" value="{{line.number}}">{{ line.number }}
                            - {{ line.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </form>
                </div>
              </ng-container>
              <ng-container *ngIf="warningsListSize > 0 && warningsListShow.length == 0">
                <div class="row alertsHomepageCollapse">
                  <hr class="hr-alerts">
                  <div class="col-lg-12 col-12">
                    <p class="fw-800 text-center mb-0 mt-1-rem">{{ homeInfo.Avisos_Alertas_Sem_Avisos_Filtros }}</p>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="warningsListSize > 0 && warningsListShow.length > 0">
                <div *ngFor="let group of warningsListShow; let i = index;" class="row alertsHomepageCollapse">
                  <hr class="hr-alerts">
                  <div class="col-lg-2 col-12 align-self-center">
                    <p class="fw-800 text-center mb-0">{{ group.Inicio }}</p>
                  </div>
                  <div class="col-lg col-12 p-0">
                    <div class="accordion" [id]="'alertAccordion' + i">
                      <div class="mt-2" *ngFor="let warning of group.Avisos; let j= index;">
                        <div class="accordion-item">
                          <h2 class="accordion-header" [id]="'warning-' + i + '-' + j">
                            <button title="Botão Alertas" class="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse"
                                    [attr.data-bs-target]="'#warningText-' + i + '-' + j" aria-expanded="false">
                              <i *ngIf="warning.Tipo.TipoAlerta == 'Alerta'"
                                 class="uil uil-exclamation-triangle color-warning me-2"></i>
                              <i *ngIf="warning.Tipo.TipoAlerta == 'Informativo'"
                                 class="uil uil-info-circle color-info me-2"></i>
                              <i *ngIf="warning.Tipo.TipoAlerta == 'Obras'"
                                 class="uil uil-traffic-barrier color-warning me-2"></i>
                              <span *ngIf="warning.Intervalo">{{ warning.Intervalo }} - </span>
                              {{ warning.Titulo }}
                            </button>
                          </h2>
                          <div [id]="'warningText-' + i + '-' + j" class="accordion-collapse collapse"
                               [attr.data-bs-parent]="'#alertAccordion' + i">
                            <div class="accordion-body">
                              <p class="mt-3 fs-14px" [innerHTML]="warning.Texto"></p>
                              <div class="mt-auto">
                                <p *ngIf="warning.Municipios && warning.Municipios.length > 0" class="mt-3">
                                  <strong>Municípios: </strong>{{ warning.municipalities_string }}</p>
                                <p *ngIf="warning.Linhas && warning.Linhas.length > 0" class="mt-3"><strong>Linhas: </strong>{{ warning.Linhas }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ----- Section Planeador ----- -->
    <div class="bg-shape-homepage">
      <div class="container ptb-350-120 gx-lg-0 gx-5">
        <div class="row justify-content-lg-end justify-content-center text-lg-start text-center">
          <div class="col-lg-6 col-12">
            <h2 aria-label="heading" class="color-primary">{{ homeInfo.Titulo_Planeador }}</h2>
            <h3 class="fs-2rem"><span>{{ homeInfo.Subtitulo_Planeador }}</span></h3>
            <button title="Botão Planeador" class="btn-custom btn-3 my-3" [routerLink]="'/planeador'">
              <span><p class="my-auto fw-600">{{ homeInfo.Botao_Planeador }}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-shape-big-section">
      <!-- ----- Section Paragens ----- -->
      <div class="container ptb-50 gx-lg-0 gx-5">
        <div class="row justify-content-center text-lg-start text-center">
          <div class="col-lg-6 col-12 my-auto">
            <h2 class="color-primary">{{ homeInfo.Titulo_Paragens }}</h2>
            <h3 class="fs-2rem color-white text-shadow-linhas">{{ homeInfo.Subtitulo_Paragens }}</h3>
            <button title="Botão Paragens" class="btn-custom btn-3 my-3" [routerLink]="'/paragens'">
              <span><p class="my-auto fw-600">{{ homeInfo.Botao_Paragens }}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span>
            </button>
          </div>
          <div class="col-lg-4 col-12 d-flex justify-content-center">
            <img src="../../../assets/img/escudo1.png" class="img-fluid img-escudo" alt="Descubra todas as Paragens">
          </div>
        </div>
      </div>
      <!-- ----- Section Horários ----- -->
      <div class="container pt-60 pb-120 gx-lg-0 gx-5">
        <div class="row justify-content-center text-lg-start text-center">
          <div class="col-lg-4 col-12 order-lg-0 order-2 d-flex justify-content-center">
            <img src="../../../assets/img/escudo2.png" class="img-fluid img-escudo" alt="Descubra todos as Horários">
          </div>
          <div class="col-lg-6 col-12 my-auto order-lg-0 order-1">
            <h2 class="color-primary">{{ homeInfo.Titulo_Horarios }}</h2>
            <h3 class="fs-2rem"><span>{{ homeInfo.Subtitulo_Horarios }}</span></h3>
            <button title="Botão Horários" class="btn-custom btn-3 my-3" [routerLink]="'/horarios'">
              <span><p class="my-auto fw-600">{{ homeInfo.Botao_Horarios }}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span>
            </button>
          </div>
        </div>
      </div>
      <!-- ----- News ----- -->
      <div *ngIf="newsListSize > 0" class="newsHomepage">
        <div class="container pb-120 px-0 gx-lg-0 gx-5">
          <div class="row justify-content-center m-0">
            <div class="col-lg-9 col-md-12 col-10 p-0">
              <div class="row justify-content-between align-items-center bg-secondary py-3 bdr-r-t-10 bdr-c-ltr">
                <div class="col-auto">
                  <h6 class="fs-20px bold color-white m-0">{{ homeInfo.Titulo_Noticias }}</h6>
                </div>
                <div class="col text-end">
                  <p class="m-0">
                    <a class="btn-link-custom fw-700" [routerLink]="'/noticias'">{{ 'buttons.verTodasNoticias' | translate }}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
                  </p>
                </div>
              </div>
              <div class="row justify-content-center bg-grey-soft p-custom-3rem bdr-r-b-10 bdr-c-lbr newsHomepageCards">
                <div *ngFor="let item of newsList" class="col-lg-4 col-12 bdr-r-10 bg-white p-2 space-news mb-3 mb-lg-0">
                  <div class="d-lg-flex d-block flex-wrap h-100">
                    <div class="newsSectionCards-image">
                      <a (click)="goToNews(item.documentId)">
                        <img [src]="item.Imagem.url" alt="Imagem Notícias" class="card-img-top">
                      </a>
                    </div>
                    <p class="news-date-font w-100">{{ item.formattedDate }}</p>
                    <p class="fw-800 fs-14px w-100">{{ item.Titulo }}</p>
                    <div class="mt-auto">
                      <a (click)="goToNews(item.documentId)" class="btn btn-link fw-700 px-0">{{ homeInfo.Link_Ler_Noticia }}<i class="uil uil-eye ms-2 fs-20px"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

